/**
 * UI_GUIDELINES §5 ProgressBar: neutral track, accent fill. There is no
 * colour per state — "done" is communicated by the label, not a green bar.
 */
export function ProgressBar({ value, max, className = '' }: { value: number; max: number; className?: string }) {
  const pct = max > 0 ? Math.min(100, Math.round((value / max) * 100)) : 0;
  return (
    <div
      role="progressbar"
      aria-valuenow={value}
      aria-valuemin={0}
      aria-valuemax={max}
      className={`h-1.5 w-full overflow-hidden rounded-full bg-surface-3 ${className}`}
    >
      <div className="h-full rounded-full bg-accent transition-[width] duration-base" style={{ width: `${pct}%` }} />
    </div>
  );
}
